import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';

//reemplazando valores de iniciales en estado

export default function ModalAccount(props) {
  const account = props.model;

  return (
    <Modal
      title="Cuenta"
      model={account}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="pymt/account"
    >
      <TextField
        label="Cuenta"
        name="account"
        margin="normal"
        fullWidth
        defaultValue={!!account ? account.account : ''}
        onKeyPress={(e) => {
          var key = window.event ? e.which : e.keyCode;
          if (key < 48 || key > 57) {
            return e.preventDefault();
          }
        }}
        inputProps={{
          maxLength: 16,
          minLength: 8
        }}
        required
      />
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={!!account ? account.description : ''}
      />
    </Modal>
  );
}
